export function regexTextSearch(text: string, searchQuery: string) {
	// Escape special characters in the search query
	const escapedQuery = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

	// Match words in any order, allowing partial word matches
	const regexPattern = escapedQuery
		.split(/\s+/)
		.map((word: string) => `(?=.*${word})`)
		.join('');
	const regex = new RegExp(regexPattern, 'i'); // Case-insensitive search

	return regex.test(text);
}
